import { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading, Layout, Text } from '../../components/core';
import { PageContent, PageError, PageFooter, PageTopBar } from '../../components/page';
import { getRoute, useSearchParams } from '../../routes';
import { SignupPasswordForm } from './forms/SignupPasswordForm';
import { useLoginRedirect } from './hooks/useLoginRedirect';

export const SignupFinishPage = (): JSX.Element => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const loginRedirect = useLoginRedirect();

  const token = searchParams.get('token') ?? '';
  const tokenId = searchParams.get('tokenId') ?? '';

  if (!token || !tokenId) {
    return <PageError showContact />;
  }

  const onBackPress = (): void => {
    navigate(getRoute('login', {}));
  };

  const onPasswordSuccess = (): void => {
    void loginRedirect();
  };

  return (
    <PageContent paddingTop={4} pageSize="medium" testID="signup-page">
      <PageTopBar
        backAccessibilityLabel="Back to Login."
        backTitle="Back"
        onBackPress={onBackPress}
        paddingBottom={8}
      />

      <Layout.VStack space={4}>
        <Layout.VStack space={4}>
          <Heading.h3>Create a password</Heading.h3>

          <Text.para>
            Passwords must be at least 8 characters and include at least one uppercase letter, one
            lower case letter, one number and one special character (!, @, #, $, %, ^, &, *)
          </Text.para>

          <SignupPasswordForm token={token} tokenId={tokenId} onSuccess={onPasswordSuccess} />
        </Layout.VStack>
      </Layout.VStack>

      <PageFooter />
    </PageContent>
  );
};
